import type { CustomStep, CustomStepType, StatusActivityStatus } from '@shared/patient-intake-status';

const statusPriority: Record<StatusActivityStatus, number> = {
  ERROR: 1,
  NOT_STARTED: 2,
  PENDING: 3,
  COMPLETED: 4,
};

const getStatusPriority = (status: StatusActivityStatus | undefined) => (status ? statusPriority[status] : 0);

/**
 * Sort steps by status, ERROR, NOT_STARTED, PENDING, COMPLETED
 */
export const sortCustomSteps =
  (reverse?: boolean) =>
  <TCustomStepType extends CustomStepType>(a: CustomStep[TCustomStepType], b: CustomStep[TCustomStepType]) => {
    const aPriority = getStatusPriority(a.currentStatus?.status);
    const bPriority = getStatusPriority(b.currentStatus?.status);

    // If reverse is true, we want to sort from highest to lowest priority
    if (reverse) {
      return bPriority - aPriority;
    }

    // If reverse is false, we want to sort from lowest to highest priority
    return aPriority - bPriority;
  };
